export default "__VITE_ASSET__DwYFYrt5__"